import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { ListItemData } from 'src/app/app-components/list-item/list-item-data';
import { ReportWellnessSurveyComponent } from 'src/app/app-components/report-wellness-survey/report-wellness-survey.component';
import { MemberInfoService } from 'src/app/services/member-info.service';
import { AssessmentForMember } from 'src/app/services/models/assessment-for-member';
import { AssessmentQuestion } from 'src/app/services/models/assessment-question';
import { AssessmentType } from 'src/app/services/models/assessment-type';
import { CodeNamePair } from 'src/app/services/models/code-name-pair';
import { AttestationPeriod } from 'src/app/services/models/member-lab-attestation';
import { AssessmentAnswer } from 'src/app/services/models/requests/wellnessSurveyQuestionAnswer';
import { wellnessSurvey } from 'src/app/services/models/wellnessSurvey';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-member-assessments',
  templateUrl: './member-assessments.component.html',
  styleUrl: './member-assessments.component.scss'
})
export class MemberAssessmentsComponent {
  @Input() memberCIN: string;
  @Input() calProviderId: string;
  @Output() onsavesuccess = new EventEmitter();
  @Output() onsavefailed = new EventEmitter();
  @Output() onchange = new EventEmitter();

  @ViewChild('reportwellnesssurvey') reportwellnesssurvey: ReportWellnessSurveyComponent

  public measurementperiodlist : CodeNamePair[] = [];
  public assessments: AssessmentType[] = [];
  public displayassessments: ListItemData[] = [];
  public attestationPeriods: AttestationPeriod[] = [];
  public selectedmeasurementperiod: CodeNamePair;
  public currentmeasurementperiod: CodeNamePair;
  public selectedassessment: ListItemData;
  public assessmentForMember: AssessmentForMember[] = [];
  public assessmentQuestions: AssessmentQuestion[] = [];
  public surveyQuestionAnswers: wellnessSurvey[] = [];
  public changeOccurred: boolean;
  public showConfirmMessage: boolean;
  public confirmMessage: string;
  public completionscore: number = 0;

  constructor(private memberService: MemberInfoService, 
    private sessionService: SessionService,
    private confirmationService: ConfirmationService) {
      
  }

  ngOnInit(): void {

    this.memberService.getMembersLabAttestationPeriods().subscribe(x=>{
      this.attestationPeriods = x;
      this.measurementperiodlist = [];

      x.forEach(y=>{
        let pair: CodeNamePair = new CodeNamePair();
        pair.code = y.measurementPeriod;
        pair.name = y.description;

        this.measurementperiodlist.push(pair);
      });

      this.selectedmeasurementperiod = this.measurementperiodlist[0];
      this.currentmeasurementperiod = this.selectedmeasurementperiod;
      this.showAssessments();
    });
  }

  public get canSubmit() : boolean {
    
    if(this.sessionService.isInternalUser) {
      return false;
    }
    else {
      let attestationPeriod:AttestationPeriod = this.attestationPeriods.find(x=>x.measurementPeriod.trim().toUpperCase() === this.selectedmeasurementperiod.code.trim().toUpperCase());
      return (attestationPeriod) ? attestationPeriod.availableToAttest : false;
    }
  }

  public showAssessments() {    

    var codes:string[] = ['PG10','CRAFFT','RPM','CGAS'];

    this.displayassessments = [];
    this.memberService.getAssessmentType(this.memberCIN, this.calProviderId, this.selectedmeasurementperiod.code,codes).subscribe(x=>{
      this.assessments = x;
      this.assessments.forEach(y=>{
        const assessment: ListItemData = {
          id: y.id,
          name: y.name,
          description: y.description,
          status: y.status ? y.status : 0,
          action: 'Take the ' + y.name + ' Survey',
          imgsrc: ''
        };

        this.displayassessments.push(assessment);
      });
    });
  }

  public showAnswers() {

    if(this.selectedassessment == null)
      return;

    this.assessmentForMember = [];    
    this.assessmentQuestions = [];
    this.surveyQuestionAnswers = [];

    forkJoin([
      this.memberService.getAssessmentQuestions(this.selectedassessment.id),
      this.memberService.getAssessmentForMember(this.selectedassessment.id, this.selectedmeasurementperiod.code, this.memberCIN, this.calProviderId),
    ]).subscribe(results=>{
      this.assessmentQuestions = results[0];
      this.assessmentForMember = results[1];

      this.assessmentQuestions.forEach(question => {

        var answerItem = this.assessmentForMember.find(x=>x.questionId === question.id);

        var item: wellnessSurvey = {
          align : question.align,
          id : question.id,
          options : question.options.split('|'),
          type : question.type,
          answer : answerItem ? answerItem.answer : '',
          checkedAnswer : [],
          question : question.question,
          requireExplanation: question.requireExplanation,
          explaination: answerItem ? answerItem.answerDetails : ''
        }

        this.surveyQuestionAnswers.push(item);
      });    

      this.reportwellnesssurvey.setWellnessSurvey(this.surveyQuestionAnswers, '');
    })
  }

  public onMPChange($event) {
    if(this.changeOccurred) {
      this.confirmationService.confirm({
        header: 'Assessments',
        message:  "There are changes in current measurement period - " + this.currentmeasurementperiod.code + ". Do you still want to continue?",
        key: 'continueDialog',
        accept: () => {
          this.selectedassessment = null;
          this.showAssessments();
          this.changeOccurred = false;
        },
        reject: () => {
          this.selectedmeasurementperiod = this.currentmeasurementperiod;
        }
      });
    }
    else {
      this.currentmeasurementperiod = this.selectedmeasurementperiod;
      this.selectedassessment = null;
      this.showAssessments();
      this.changeOccurred = false;
    }
  }
  
  public oninputchange($event) {
    this.onchange.emit();
    this.changeOccurred = true;
  }

  public saveAssessment() {
  
    const answers: AssessmentAnswer[] = [];
    this.surveyQuestionAnswers.forEach(x=>{
      var answer: AssessmentAnswer = {
        QuestionId:x.id,
        Answer:x.answer.toString(),
        AnswerDetails:x.explaination
      };
      if(answer.Answer && answer.Answer != '')
        answers.push(answer);
    });

    var status: number = (answers.length > 0) ? 2 : 0;

    var item = this.assessments.find(x=>x.status == 2 && x.id != this.selectedassessment.id);

    if(item) {
      this.confirmationService.confirm({
        header: 'Assessments',
        message:  "Assessment " + item.name + " is already completed. Do you wish to override ?",
        key: 'continueDialog',
        accept: () => {
          this.memberService.updateAssessmentForMember(this.selectedassessment.id, this.selectedmeasurementperiod.code, this.memberCIN, this.calProviderId, status, answers).subscribe(x=>{
            this.onsavesuccess.emit();
            this.changeOccurred = false;
          },
          (error)=>{
            this.onsavefailed.emit();
          });
        },
        reject: () => {

        }
      });
    }
    else {
      this.memberService.updateAssessmentForMember(this.selectedassessment.id, this.selectedmeasurementperiod.code, this.memberCIN, this.calProviderId, status, answers).subscribe(x=>{
        this.onsavesuccess.emit();
        this.changeOccurred = false;
      },
      (error)=>{
        this.onsavefailed.emit();
      });      
    }
  }

  public validate(): any {

    var result = {
      "valid": true,
      "error": ''
    };

    return result;
  }

  public assessmentClicked($event) {
    this.selectedassessment = $event;

    this.showAnswers();
  }
}
